/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-destructuring */
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable class-methods-use-this */
/* eslint-disable block-scoped-var */
/* eslint-disable no-var */
/* eslint-disable no-eval */
/* eslint-disable no-restricted-syntax */
/* eslint-disable camelcase */
import { Feature } from 'ol';
import GeoJSONFormat from 'ol/format/GeoJSON';
import BaseLayer from 'ol/layer/Base';
import VectorLayer from 'ol/layer/Vector';
import sanitizeHtml from 'sanitize-html';
import AbstractLayerTreeElement from './AbstractLayerTreeElement';
import AuthenticationInfos from './AuthenticationInfos';
import DatavizConfig from './DatavizConfig';
import GeometryType from './GeometryType';
import Layer3dConfig from './Layer3dConfig';
import LayerAttribute from './LayerAttribute';
import LayerStyle from './LayerStyle';
import LayerStyleComplex from './LayerStyleComplex';
import ModelConfig from './cesium/ModelConfig';
import StyleRule from './style/StyleRule';
import LayerConfigMapLibre from './LayerConfigMapLibre';
import CircleStyle from 'ol/style/Circle';
import { Circle, Fill, Stroke, Style, Text } from 'ol/style';
import LayerConfigQgis from './LayerConfigQgis';
import { Observable } from 'rxjs/internal/Observable';
import { from, of } from 'rxjs';
import axios from 'axios';
import GeoJSON from 'ol/format/GeoJSON';
import { map } from 'rxjs/operators';
import LayerIndicators from './LayerIndicators';

export default class LayerConfig extends AbstractLayerTreeElement {

  layername!: string;

  title!: string;

  tiled = true;

  applicableCoupe = '';

  description = '';

  outputFormat!: string;

  protocol!:string;

  mbStyleUrl!:string;

  mbStyleResponse!:any;

  getFeatureInfoFormat = 'application/json';

  Attribution: any = {};

  metadataUrl = '';

  geometryType!: string;

  filter!: string;

  tableFilter!: string;

  geometricFilter!: string;

  tableGeometricFilter!: string;

  dataviz= new DatavizConfig();

  selectionColor= '';
  // Fiche Infos
  ficheInfos = { content: '', enabled:true,zoomtoFeature:false, showNearFeatureList:true,active: false, edited: false,width:30 };

  // Infobulle
  popupInfos = { content: '', active: false, edited: false };

  featureInfoContentRenderer!:(feature:Feature<any>, target:HTMLElement) => void;

  authenticationInfos= new AuthenticationInfos();

  modelConfig!:ModelConfig;

  jsonData!: string;


  projection!: string;

  dataProjection!: string; // projection des données

  styles: any;

  useSldBody = false;

  opacity?: number = 1;

  layerProperties: LayerAttribute[]=Array<LayerAttribute>();

  visible = false;

  removable = true;

  editable = false;

  cluster = false;

  clusterConfig={"distance":100,"minDistance":20,style:new LayerStyle()}

  editing = false;

  queryable = true;

  targetNamespace!: string;

  targetPrefix!: string;

  isLegendDisplayed = true;

  legendImageUrl = '';

  public baseLayer = false;

  layerIndex!: number;

  maxScaleDenominator!: number;

  minScaleDenominator!: number;

  boundingBoxEPSG4326!: number[];

  url!: string;

  ol_Layer?: BaseLayer;

  cesium_Layer?:any;

  style = new LayerStyle();

  complexStyle = new LayerStyleComplex();

  indicators = new LayerIndicators();

  maxFeatures = 5000;

  selectedStyle: any;

  error = {show:false,
           type:-1,
          message:''};

  idProperty='';

  useProxy = false;

  ignoreUrlInCapabiltiesResponse = false;

  isWFsAble = false; // indique si une couche WMS est aussi disponible en WFS

  isWmtsAble = false; // indique si une couche WMS est aussi disponible en WMTS

  layer3dConfig = new Layer3dConfig();

  drawStyle:Style;

  constructor(input?: any) {
    super(input);
    if (input) {
      this.loadFromJson(input);
    }
    this.drawStyle = new Style({
      fill: new Fill({
        color: 'rgba(255, 255, 255, 0.2)'
      }),
      stroke: new Stroke({
        color: 'rgba(0, 0, 255, 0.5)',
        lineDash: [],
        width: 2
      }),
      image: new Circle({
        radius: 7,
        stroke: new Stroke({
          color: 'rgba(255, 0, 0, 0.5)',
          lineDash: [],
          width: 2
        }),
        fill: new Fill({
          color: 'rgba(255, 255, 255, 0.5)'
        })
      }),
      text: new Text({
        font: '12px Calibri,sans-serif',
        fill: new Fill({ color: '#000' }),
        stroke: new Stroke({
          color: '#fff',
          width: 1
        }),
        // get the text from the feature - `this` is ol.Feature
        text: ''
      }),
      zIndex: 50
    });
  }

  loadFromJson(input:any) {
    Object.assign(this, input);
    this.style = new LayerStyle(input.style);
    if (!this.Attribution) {
      this.Attribution = {};
    }
    this.fixIgnUrls();
    //this.url=this.url.replace('https://geoservices-test.geofit.fr','http://localhost/cnes_rec');
    if(this.cluster){
      if(input.clusterConfig.style){
        this.clusterConfig.style = new LayerStyle(input.clusterConfig.style);
      }
      else{
        this.clusterConfig.style = new LayerStyle();
        this.clusterConfig.style.textStyle.text='{nbFeatures}';
        this.clusterConfig.style.textStyle.textFontSize=20;
        this.clusterConfig.style.textStyle.halo=true;
        this.clusterConfig.style.textStyle.haloSize=2;
        this.clusterConfig.style.textStyle.offsetY=2;
        this.clusterConfig.style.pointSymbol.size=30;
        this.clusterConfig.style.pointSymbol.symbolStrokeColor="#FFFFFF";
      }

    }
    if(this.ficheInfos.enabled===undefined){
      this.ficheInfos.enabled=true;
    }
    if (input.dataviz) {
      this.dataviz = new DatavizConfig(input.dataviz);
    }
    if (input.layerProperties) {
      this.layerProperties = input.layerProperties.map((x:any) => new LayerAttribute(x));
    }
    if (input.complexStyle && input.complexStyle.styleRules) {
      this.complexStyle = new LayerStyleComplex(this.complexStyle, this.style);
    } else {
      this.complexStyle = new LayerStyleComplex();
    }
    if (input.indicators && input.indicators.indicators) {
      this.indicators = new LayerIndicators(input.indicators);
    } else {
      this.indicators = new LayerIndicators();
    }
    if (input.authenticationInfos) {
      this.authenticationInfos = new AuthenticationInfos(input.authenticationInfos);
      this.loadAuthenticationInfosFromLocalStorage();
    }
    if (input.modelConfig) {
      this.modelConfig = new ModelConfig(input.modelConfig);
    }
    if (input.config3d) {
      this.layer3dConfig = new Layer3dConfig(input.config3d);
    }
    // opacity était entre 0 et 100 et maintenant entre 0 et 1,
    // ceci pour traiter les anciennes cartes
    if (this.opacity && this.opacity > 1) {
      this.opacity /= 100;
    }
  }

  fixIgnUrls():void {
    if (this.url && this.url.indexOf('wxs.ign.fr') > 0 ) { // && this.url.indexOf('/tms/') < 0
      this.url = this.url.replace(new RegExp('wxs.ign.fr/(.*)/geoportail/', 'ig'), 'data.geopf.fr/');
      this.url = this.url.replace(new RegExp('/v/', 'ig'), '/wms-v/');
      this.url = this.url.replace(new RegExp('/r/', 'ig'), '/wms-r/');
    }
    if (this.mbStyleUrl && this.mbStyleUrl.indexOf('wxs.ign.fr') > 0 ) {
      this.mbStyleUrl = this.mbStyleUrl.replace(new RegExp('wxs.ign.fr/static', 'ig'), 'data.geopf.fr/annexes/ressources');

    }
  }

  checkSourceAuthentification():void {
    this.loadAuthenticationInfosFromLocalStorage();

    if (this.authenticationInfos !== undefined && this.authenticationInfos.isRequired()) {
      if (this.authenticationInfos.isFilled()) {
        console.log('ok auth infos provided');
      } else {
        this.addError("Cette couche nécessite des informations d'authentication");
      }
    }
  }

  clearCache() {
    this.style.clearCache();
    if(this.clusterConfig && this.clusterConfig.style && this.clusterConfig.style.clearCache){
      this.clusterConfig.style.clearCache();
    }

  }

  loadAuthenticationInfosFromLocalStorage():void {
    const localInfos = localStorage.getItem('localStorageAuthDB');

    if (localInfos !== undefined && localInfos !== null) {
      const localStorageAuthDB:any = JSON.parse(localInfos);
      const authInfos = localStorageAuthDB[this.url];
      if (authInfos) {
        this.authenticationInfos = new AuthenticationInfos(authInfos);
      }
    }
  }

  hasAuthenticationInfos():boolean {
    return this.authenticationInfos !== undefined && this.authenticationInfos.isFilled();
  }

  isGroup(): boolean {
    return false;
  }

  getGeomAttributeName(): string {
    if (!this.layerProperties) {
      return 'the_geom';
    }
    const geomAttr = this.layerProperties.find((x: { type: string | string[]; }) => x.type && x.type.indexOf('gml:') >= 0);
    if (!geomAttr) {
      return 'the_geom';
    }
    return geomAttr.name;
  }
  getGeomGmlAttributeType(): string {
    if (!this.layerProperties) {
      return 'unknown';
    }
    const geomAttr = this.layerProperties.find((x: { type: string | string[]; }) => x.type && x.type.indexOf('gml:') >= 0);
    if (!geomAttr) {
      return 'unknown';
    }
    return geomAttr.type;
  }

  hasMandatoryProperties() {
    if (!this.layerProperties) {
      return false;
    }
    const mandatoryAttr:LayerAttribute[] = this.layerProperties.filter((x: any) => x.isMandatory());
    return mandatoryAttr.length>0;

  }
  getLayerPropertieByName(name:string) {
    if (!this.layerProperties) {
      return undefined;
    }
    const attributes:LayerAttribute[] = this.layerProperties.filter((x: any) => x.name==name);
    if(attributes.length==0){
      return undefined;
    }
    return attributes[0];

  }

  getIdPropery(): string {
    const retour = '';
    if (this.idProperty !== '') {
      return this.idProperty;
    }
    if (this.layerProperties && this.layerProperties.length > 0) {
      console.log(this.layerProperties);
      const props = this.layerProperties.filter((x: { name: string; }) => x.name.toLowerCase().indexOf('id') >= 0);
      console.log(props);
      if (props.length > 0) return props[0].name;
    }
    return retour;
  }

  setVisible(visible: boolean): void {
    this.visible = visible;
    if (this.cesium_Layer) {
      this.cesium_Layer.show = this.isLayerVisible();
    }
    else if (this.ol_Layer) {
      this.ol_Layer.setVisible(this.isLayerVisible());
    }
    
  }

  getOpacity() {
    if (this.ol_Layer) {
      return this.ol_Layer.getOpacity();
    }
    if (this.cesium_Layer) {
      return this.cesium_Layer.alpha;
    }
    return undefined;
  }

  setOpacity(opacity: number): void {
    if (this.cesium_Layer) {
      this.cesium_Layer.alpha = opacity;
    }
    else if (this.ol_Layer) {
      this.ol_Layer.setOpacity(opacity);
    }
    
  }

  guessGeometryType(): string {
    let retour = GeometryType.UNDEFINED;
    if (this.ol_Layer && this.ol_Layer instanceof VectorLayer) {
      const layer: VectorLayer<any> = <VectorLayer<any>> this.ol_Layer;
      const features = layer.getSource().getFeatures();
      if (features && features.length > 0) {
        let type = '';
        const geom = features[0].getGeometry();
        if (geom) {
          type = geom.getType();
        }
        if (type === 'MultiLineString' || type === 'LineString') {
          retour = GeometryType.LINE;
        } else if (type === 'MultiPolygon' || type === 'Polygon') {
          retour = GeometryType.POLYGON;
        } else if (type === 'MultiPoint' || type === 'Point') {
          retour = GeometryType.POINT;
        }
      }
    }
    return retour;
  }

  getFilterValue(): string {
    // eslint-disable-next-line no-useless-escape
    const filterChildByAttribute = new RegExp(/\{([^\}]*)\}/g);
    let filter = '';
    if (this.filter && this.filter.indexOf('{') >= 0) {
      filter = this.filter.replace(filterChildByAttribute, (a, b, c) => eval(b));
    } else if (this.filter) {
      filter = this.filter;
    }
    if (this.geometricFilter && this.geometricFilter.length > 0) {
      if (filter.length > 0) {
        filter = `(${filter} AND ${this.geometricFilter})`;
      } else {
        filter = this.geometricFilter;
      }
    }
    // add Filter from user Selection In LayerPanel if needed
    if (this.complexStyle && this.complexStyle.displayInLayerPanel) {
      this.complexStyle.styleRules.forEach((rule:StyleRule) => {
        if (!rule.active) {
          if (filter.length > 0) {
            filter = `(${filter} AND (NOT (${rule.value})))`;
          } else {
            filter = `NOT (${rule.value})`;
          }
        }
      });
    }

    return filter;
  }

  /**
  * Filtre pour la table attributaire
  */
  getTableFilterValue(): string {
    let filter = this.getFilterValue();
    if (this.tableFilter && this.tableFilter.length > 0) {
      if (filter && filter.length > 0) {
        filter = `(${filter} AND ${this.tableFilter})`;
      } else {
        filter = this.tableFilter;
      }
    }
    if (this.tableGeometricFilter && this.tableGeometricFilter.length > 0) {
      if (filter && filter.length > 0) {
        filter = `(${filter} AND ${this.tableGeometricFilter})`;
      } else {
        filter = this.tableGeometricFilter;
      }
    }
    return filter;
  }

  hasEditionCapabilities():boolean {
    return this.type === 'WFS' || this.type === 'Vector';
  }

  hasAnalyseDisplayedInLayerPanel():boolean {
    return this.complexStyle && this.complexStyle.displayInLayerPanel;
  }

  hasRules():boolean {
    return this.complexStyle && this.complexStyle.styleRules.length > 0;
  }

  getDrawStyle(): any{
    return this.drawStyle;
  }

  getEditStyle(mapService:any): any{
    return this.drawStyle;

  }

  getStyleFunction(): any {
    
    let retour:any = (feature:any, resolution:any) => this.style.getStyle(feature, resolution);

    /*
    let retour:any = (feature:any, resolution:any) => {
      if(feature.properties_ && feature.properties_.layer && feature.properties_.layer!=this.layername)
        return;
      return this.style.getStyle(feature, resolution);
    }*/

    if (this.complexStyle
      && this.complexStyle.styleRules
      && this.complexStyle.styleRules.length > 0) {
      retour = (feature:any, resolution:any) => {
        const s = this.complexStyle.getStyle(feature, resolution);
        if (s) {
          return s;
        }

        return null;
      };
    }
    return retour;
  }

  getClusterStyleFunction(): any {
    let styleFunction=(features:any)=>{
      const size = features.get('features').length;
      if (size > 1) {
        let f=features.get('features')[0].clone()
        let newProps=f.getProperties();
        newProps['nbFeatures']=size;
        f.setProperties(newProps,true);
        let st= this.clusterConfig.style.getStyle(f);

        return st;
      }
      const originalFeature = features.get('features')[0];
      return this.getStyleFunction()(originalFeature);
    }
    return styleFunction;
  }

  geometryTypeNotDefined():boolean {
    return this.geometryType === undefined
    || this.geometryType === GeometryType.UNDEFINED;
  }

  getBaseUrl(): string {
    let urlwms = '';
    if (this.url != undefined && this.url != "") {
      urlwms = this.url;
    }
    let searchMask = "(&?)request(=|%3D)getCapabilities";
    let regEx = new RegExp(searchMask, "ig");
    let replaceMask = "";

    urlwms = urlwms.replace(regEx, replaceMask);

    searchMask = "(&?)service(=|%3D)wms";
    regEx = new RegExp(searchMask, "ig");

    urlwms = urlwms.replace(regEx, replaceMask);

    searchMask = "(&?)version(=|%3D)(1.3.0|1.1.1|1.1.0)";
    regEx = new RegExp(searchMask, "ig");

    urlwms = urlwms.replace(regEx, replaceMask);

    return urlwms;
  }
  getCapabilitiesUrl(): string {


    let url =this.url;

    let searchMask = 'service(=|%3D)(wms|ows)';
    let regEx = new RegExp(searchMask, 'ig');
    if (!regEx.test(url) && this.isWMS()) {
      if(url.indexOf('?') >= 0) {
        url=`${url}&service=wms`;
      }
      else{
        url=`${url}?service=wms`;
      }
    }
    searchMask = 'getCapabilities';
    regEx = new RegExp(searchMask, 'ig');
    if (regEx.test(url)) {
      return url;
    }
    if(url.indexOf('?') >= 0) {
      return `${url}&request=getCapabilities`;
    }
    else{
      return `${url}?request=getCapabilities`;
    }

  }
  getBuffer():number{
    let buffer=5;
      if(this.geometryType!==undefined && this.geometryType==GeometryType.POLYGON){
        buffer = 0;
      }
    return buffer;
  }
  getFeatureInfoUrl():string {
    if (this.isWMS() && this.url.indexOf('?') >= 0) {
      const i = this.url.indexOf('?');
      let buffer=this.getBuffer();
      const url = `${this.url.slice(0, i + 1)}service=wms&version=1.3.0&request=GetFeatureInfo&QUERY_LAYERS=${this.layername}&layers=${this.layername}&EXCEPTIONS=XML&INFO_FORMAT=application/json&BUFFER=${buffer}&FEATURE_COUNT=10&FI_LINE_TOLERANCE=10&FI_POINT_TOLERANCE=25&FI_POLYGON_TOLERANCE=5`;
      return url;
    }
    return '';
  }

  getDownloadUrl(format: any): string|undefined {
    let capabilitiesUrl = this.getCapabilitiesUrl();
    let regEx = new RegExp('getCapabilities', 'ig');
    if (format.type === 'WMS') {
      const urlservice = capabilitiesUrl.replace(regEx, 'GetMap');
      return `${urlservice}&version=1.3.0&format=${format.value}&layers=${this.layername}&WIDTH=1320&HEIGHT=700&CRS=EPSG:4326&BBOX=${this.boundingBoxEPSG4326[1]},${this.boundingBoxEPSG4326[0]},${this.boundingBoxEPSG4326[3]},${this.boundingBoxEPSG4326[2]}`;
    }
    if (this.isWMS()) { // si c'est une couche WMS, on recupère l'url du flux WFS associé
      capabilitiesUrl = this.wmsUrlToWfs(capabilitiesUrl);
    }
    const urlservice = capabilitiesUrl.replace(regEx, 'GetFeature');
    regEx = new RegExp('service(=|%3D)wms', 'ig');
    return `${urlservice.replace(regEx, 'service=WFS')}&outputFormat=${format.value}&TypeNames=${this.layername}&TypeName=${this.layername}`;
  }

  getDescribeFeatureUrl(): string {
    if (this.isWMS() && this.url.indexOf('?') >= 0) {
      const wfsUrl = this.wmsUrlToWfs(this.url);
      const i = wfsUrl.indexOf('?');
      const url = `${wfsUrl.slice(0, i + 1)}service=wfs&version=2.0.0&request=DescribeFeatureType&TypeNames=${this.layername}&TypeName=${this.layername}`;
      return url;
    }
    if (this.isWMS() && this.url.indexOf('ows') >= 0) {
      const url = `${this.url}?service=wfs&version=2.0.0&request=DescribeFeatureType&TypeNames=${this.layername}&TypeName=${this.layername}`;
      return url;
    }
    if (this.isWFS()) {
      const regEx = new RegExp('request(=|%3D)getCapabilities', 'ig');
      const replaceMask = 'request=DescribeFeatureType';
      const url = `${this.url.replace(regEx, replaceMask)}&TypeNames=${this.layername}&TypeName=${this.layername}`;// &outputFormat=application/json
      return url;
    }
    if (this.isWMTS() || this.isVectorTile()) {
      const serviceRegex = new RegExp('gwc/service/wmts', 'ig');
      const serviceRegEx2 = new RegExp('service(=|%3D)wmts', 'ig');
      let url = this.url.replace(serviceRegex, 'wfs').replace(serviceRegEx2, 'service=wfs');
      const regEx = new RegExp('request(=|%3D)getCapabilities', 'ig');
      const replaceMask = 'request=DescribeFeatureType';
      url = `${url.replace(regEx, replaceMask)}&TypeNames=${this.layername}&TypeName=${this.layername}&outputFormat=application/json`;
      return url;
    }
    return '';
  }

  getFeatureWFSUrl():string {
    const searchMask = 'getCapabilities';
    const regEx = new RegExp(searchMask, 'ig');
    const replaceMask = 'GetFeature';
    let url=this.getCapabilitiesUrl().replace(regEx, replaceMask);
    return url;
  }

  getWmtsCapabilitiesUrl():string {
    let url = this.getCapabilitiesUrl();

    // Pour Geoserver, on peut chercher a trouver l'url WMTS à partir du WMS
    // Si c'est une couche WMS, on transforme l'url pour pointer vers
    if (this.isWMS()) {
      let searchMask = '/(ows|wms)';
      let regEx = new RegExp(searchMask, 'ig');
      let replaceMask = '/gwc/service/wmts';
      url = url.replace(regEx, replaceMask);
      searchMask = 'service(=|%3D)(wms|ows)';
      regEx = new RegExp(searchMask, 'ig');
      replaceMask = 'service=WMTS';
      url = url.replace(regEx, replaceMask);
      searchMask = 'version(=|%3D)(1.3.0|1.1.1|1.1.0)';
      regEx = new RegExp(searchMask, 'ig');
      replaceMask = '';
      url = url.replace(regEx, replaceMask);
    }
    const searchMask = 'service(=|%3D)wmts';
    const regEx = new RegExp(searchMask, 'ig');
    if (regEx.test(url)) {
      return url;
    }

    url += '&service=WMTS';
    return url;
  }

  wmsUrlToWfs(url:string):string {
    const serviceRegex = new RegExp('service(=|%3D)wms', 'ig');
    const versionRegex = new RegExp('version(=|%3D)1.3.0', 'ig');
    const wmsRegex = new RegExp('(wms|ows)', 'ig');

    if(!versionRegex.test(url)){
      url+= '&version=1.3.0';
    }

    return url.replace(serviceRegex, 'service=wfs').replace(versionRegex, 'version=2.0.0').replace(wmsRegex, 'wfs');
  }

  wfsUrlToWms(url:string):string {
    const serviceRegex = new RegExp('service(=|%3D)wfs', 'ig');
    const versionRegex = new RegExp('version(=|%3D)2.0.0', 'ig');
    const wfsRegex = new RegExp('wfs', 'ig');
    return url.replace(serviceRegex, 'service=wms').replace(versionRegex, 'version=1.3.0').replace(wfsRegex, 'wms');
  }

  hasMapBoxStyle():boolean {
    return this.protocol === 'TMS'
      && this.type === 'VectorTile'
      && this.mbStyleUrl !== undefined && this.mbStyleUrl.length > 0;
  }

  isStylable():boolean {
    return this.type !== 'COG' && this.type !== 'WMTS' && this.type !== '3DTiles_Photomaillage' && this.type !== '3DTilesPointCloud' && this.type !== '3DTiles'
      && !this.hasMapBoxStyle();
  }

  isCutable():boolean {
    return this.type === '3DTiles_Photomaillage' || this.type === '3DTiles' || this.is3DModel();
  }

  is3Dtiles() {
    return this.type === '3DTiles_Photomaillage' || this.type === '3DTiles';
  }

  is3DModel() {
    return this.type === '3dmodel';
  }

  getWFSUrl(extent:any, projection:any,ignorebbox=false): string {
    const urlservice = this.getFeatureWFSUrl();
    let outputformat = 'application/json';
    if (this.outputFormat) {
      outputformat = encodeURIComponent(this.outputFormat);
    }

    let proj = 'EPSG:3857';
    let url = `${urlservice
    }&maxfeatures=${this.maxFeatures
    }&count=${this.maxFeatures
    }&typenames=${this.layername}`
      + `&typename=${this.layername}&`
      + `outputFormat=${outputformat}&srsname=${proj}`;

    if (this.filter || this.geometricFilter || this.tableFilter || this.tableGeometricFilter) {
       url += `&CQL_FILTER=`;
          if(!ignorebbox){
            url += `BBOX(${this.getGeomAttributeName()},${extent.join(',')},'${proj}') AND `;
          }  
          url += `${encodeURIComponent(this.getTableFilterValue())}`;
    } else {
      url += `&bbox=${extent.join(',')},${proj}`;
    }
    return url;
  }

  updateStyle() :void{
    if (this.type === 'WMS' && !this.hasMapBoxStyle()) {
      if (this.useSldBody) {
        const sld = this.styletoSld();
        this.getLayerSource().updateParams({ SLD_BODY: sld });
      } else {
        this.getLayerSource().updateParams({ SLD_BODY: undefined });
        if(this.selectedStyle && this.selectedStyle.length>0){
          this.getLayerSource().updateParams({ STYLES: this.selectedStyle });
        }
        if (this.getFilterValue().length > 0) {
          this.getLayerSource().updateParams({ CQL_FILTER: this.getFilterValue() });
        } else {
          this.getLayerSource().updateParams({ CQL_FILTER: undefined });
        }
      }
    } else if (!this.hasMapBoxStyle()) {
      this.style.clearCache();
      /* TODO
      if (layer.dynamicStyle) {
        layer.dynamicStyle.clearStylesCache();
      }
      */
      if (this.getOlLayer() && this.getOlLayer().setStyle) {
        this.getOlLayer().setStyle(this.getStyleFunction());
      }
    }
  }

  checkMinMaxResol() {
    if (this.maxScaleDenominator && this.minScaleDenominator && this.maxScaleDenominator < this.minScaleDenominator) {
     return {
      "success": false,
      "message": "L'échelle minimum de rendu doit être supérieure à l'échelle maximum."
     }
    }
    return {
        "success": true,
        "message": ""
      } 
  }
  getLayerName(){
    let layerName = this.layername;
    if (layerName.indexOf(':') > 0) {
      const workspace = layerName.split(':')[0];
      if (this.url.indexOf(`/${workspace}/`) > 0) {
        layerName = layerName.split(':')[1];
      }
    }
    return layerName;
  }
  styletoSld(): string {
    let rules = `<Rule>${this.style.toSld(this)}</Rule>`;
    if (this.complexStyle.isDefined()) {
      rules = this.complexStyle.toSld(this);
    }

    // REMOVE WORKSPACE FROM LAYERNAME IF ALREADY IN URL
    let layerName=this.getLayerName();
    // ---------------------------------------------------
    const sld = `<?xml version="1.0" encoding="UTF-8"?>
        <StyledLayerDescriptor version="1.0.0"
            xsi:schemaLocation="http://www.opengis.net/sld StyledLayerDescriptor.xsd"
            xmlns="http://www.opengis.net/sld"
            xmlns:ogc="http://www.opengis.net/ogc"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
          <NamedLayer>
            <Name>${layerName}</Name>
            <UserStyle>
                <Title>${layerName} style</Title>
                <Abstract></Abstract>
                <FeatureTypeStyle>
                  ${rules}
                </FeatureTypeStyle>
            </UserStyle>
            </NamedLayer>
        </StyledLayerDescriptor>`;
    return sld;
  }

  toJsonDuplication():any {
    let retour=this.toJson();
    delete retour.uid;
    retour.title+=' (Copie)'
    return retour;
  }
  toJson():any {
    var newLayer:any = {
      uid: this.uid,
      layername: this.layername,
      title: this.title,
      type: this.type,
      visible: this.isVisible(),
      useSldBody: this.useSldBody,
      dataviz: this.dataviz.toJson(),
      removable: this.removable,
      editable: this.editable,
      cluster: this.cluster,
      selectionColor: this.selectionColor,
      queryable: this.queryable,
      protocol: this.protocol,
      mbStyleUrl: this.mbStyleUrl,
      idProperty: this.idProperty,
      targetNamespace: this.targetNamespace,
      targetPrefix: this.targetPrefix,
      dataProjection: this.dataProjection,
      maxFeatures: this.maxFeatures,
      layerIndex: this.layerIndex,
      maxScaleDenominator: this.maxScaleDenominator,
      minScaleDenominator: this.minScaleDenominator,
      boundingBoxEPSG4326: this.boundingBoxEPSG4326,
      filter: this.filter,
      geometricFilter: this.geometricFilter,
      outputFormat: this.outputFormat,
      getFeatureInfoFormat: this.getFeatureInfoFormat,
      url: this.url,
      tiled: this.tiled,
      baseLayer: this.baseLayer,
      opacity: this.ol_Layer ? this.ol_Layer.getOpacity() : 1,
      isLegendDisplayed: this.isLegendDisplayed,
      legendImageUrl: this.legendImageUrl,
      description: this.description,
      popupInfos: { ...this.popupInfos },
      ficheInfos: { ...this.ficheInfos },
      style: this.style.toJson(),
      selectedStyle:this.selectedStyle,
      styles:this.styles,
      complexStyle: {},
      indicators:{},
      Attribution: this.Attribution,
      metadataUrl: this.metadataUrl,
      geometryType: this.geometryType,
      ignoreUrlInCapabiltiesResponse: this.ignoreUrlInCapabiltiesResponse,
      layerProperties: Array<any>(),
      authenticationInfos: {},
      jsonData: '',
      config3d: this.layer3dConfig.toJson(),
    };
    if (this.cluster) {
      newLayer.clusterConfig = {style:this.clusterConfig.style.toJson(),
        distance:this.clusterConfig.distance,minDistance:this.clusterConfig.minDistance
      };
    }
    if (this.modelConfig) {
      newLayer.modelConfig = this.modelConfig.toJson();
    }
    if (this.indicators) {
      newLayer.indicators = this.indicators.toJson();
    }
    if (this.complexStyle) {
      newLayer.complexStyle = this.complexStyle.toJson();
    }
    if (this.layerProperties) {
      newLayer.layerProperties = this.layerProperties.map((x:LayerAttribute) => x.toJson());
    }
    // on ne sauve pas les infos d'authentification dans la config de la carte
    // elles sont stockées dans le localstorage si l'utilisateur le demande
    if (this.authenticationInfos && this.authenticationInfos.isRequired()) {
      newLayer.authenticationInfos = { type: this.authenticationInfos.type };
    }
    if ((this.type === 'Vector'||this.type=='annotations') && this.url === undefined && this.ol_Layer && this.ol_Layer instanceof VectorLayer) {
      const feats = this.getLayerSource().getFeatures();
      const featstring = (new GeoJSONFormat()).writeFeatures(feats);
      const sizeInko = Number(featstring.length / 1024);
      if (sizeInko > 500) {
        this.addError(`Trop de données dans cette couche pour la sauvegarde( ${sizeInko} ko), vous devez supprimer des objets`);
        throw new Error('TooMuchDatas');
      } else {
        newLayer.jsonData = featstring;
        newLayer.dataProjection = 'EPSG:3857';
      }
    }

    return newLayer;
  }

  getLegendImageUrl(): string {
    if (this.legendImageUrl) {
      return this.legendImageUrl;
    }
    let url;
    if (this.ol_Layer && this.getLayerSource().urls) {
      url = this.getLayerSource().urls[0];
    } else if (this.ol_Layer) {
      url = this.getLayerSource().getUrl();
    }
    url += '&service=WMS&REQUEST=GetLegendGraphic&SLD_VERSION=1.1.0&FORMAT=image%2Fpng&WIDTH=30&HEIGHT=30&LAYER=';

    url += this.layername;

    if (this.useSldBody) {
      const sld = this.styletoSld();
      url += `&SLD_BODY=${encodeURIComponent(sld)}`;
    }
    else if(this.selectedStyle && this.selectedStyle.length>0){
      url += `&STYLE=${this.selectedStyle}`;
    }

    return url;
  }

  getAttribution(): string | undefined {
    let attributions;
    if (this.Attribution && this.Attribution.OnlineResource && this.Attribution.OnlineResource.indexOf("javascript")<0) {
      const url = encodeURI(this.Attribution.OnlineResource);
      attributions = `<a href="${url}" target="_blank">${sanitizeHtml(this.Attribution.Title)}</a> `;
    } else if (this.Attribution) {
      attributions = sanitizeHtml(this.Attribution.Title);
    }
    return attributions;
  }

  /**
   * retourne la liste des valeurs des objets de la carte
   * pour un attribut numérique
   */
  getDataValues(attribute:any,extent:any):Observable<any[]> {
    let values = [];

    if (this.isWMS() && this.hasWFSCapacity()) {
      const urlGetFeature = this.wmsUrlToWfs(this.getFeatureWFSUrl());
      const maxFeatures = this.maxFeatures;
      const url = `${urlGetFeature
      }&maxfeatures=${maxFeatures
      }&count=${maxFeatures
      }&typenames=${this.layername}`
        + `&typename=${this.layername}&`
        + 'outputFormat=json&srsname=EPSG:3857';
      return from(axios.get(url)).pipe(
        map((reponse:any) => {
          const allFeatures = new GeoJSON().readFeatures(reponse.data);
          if (!attribute) {
            return [];
          }
          return allFeatures.map((x:any) => x.get(attribute!.name));
        }),
      );
    }
    if (this.getOlLayer().getFeaturesInExtent) {
      values = this.getOlLayer()
        .getFeaturesInExtent(extent).map((x:any) => x.get(attribute!.name));
    } else {
      values = this.getLayerSource().getFeatures()
        .map((x:any) => x.get(attribute!.name));
    }
    console.log(values);
    return of(values);
  }

  getDistinctValues(attribute:any,extent:any):Observable<number[]> {
    const distinct=this.getDataValues(attribute,extent).pipe(
      map((x:any) => x.filter((v:any, i:any, a:any) => a.indexOf(v) === i)),
    ); // to get distinct values)); // to get distinct values
    return distinct;
  }

  setOL_Layer(layer: BaseLayer): void {
    this.ol_Layer = layer;
    (<any>layer).customConfig = this;
  }

  setCesium_Layer(layer: any): void {
    this.cesium_Layer = layer;
    (<any>layer).customConfig = this;
  }

  getCesiumLayer(): any {
    return this.cesium_Layer;
  }

  getOlLayer(): any {
    return this.ol_Layer;
  }

  getLayerSource(): any {
    if (this.ol_Layer) {
      if(this.cluster)
        return this.getOlLayer().getSource().getSource();
      return this.getOlLayer().getSource();
    }
    if (this.cesium_Layer) {
      return this.getCesiumLayer();
    }
    return undefined;
  }

  isWMS():boolean {
    return this.type === 'WMS';
  }

  inRange(currentScale: number):boolean {
    if (!currentScale) {
      return true;
    }
    const maxScaleOk = !this.maxScaleDenominator
    || (this.maxScaleDenominator > currentScale);
    const minScaleOK = !this.minScaleDenominator
    || (this.minScaleDenominator < currentScale);
    return maxScaleOk && minScaleOK;
  }

  hasTableCapacity():boolean {
    return this.hasWFSCapacity() || this.isVector() || this.isVectorTile();
  }

  isVectorRenderLayer():boolean {
    return this.isWFS() || this.isVector() || this.isVectorTile()||this.isOGCFeature();
  }

  isVector():boolean {
    return this.type === 'Vector';
  }

  isVectorTile():boolean {
    return this.type === 'VectorTile';
  }

  isWFS():boolean {
    return this.type === 'WFS';
  }

  isOGCFeature():boolean {
    return this.type === 'API Features';
  }

  hasWFSCapacity():boolean {
    return this.type === 'WFS' || this.isWFsAble;
  }

  hasWMTSCapacity():boolean {
    return this.isWmtsAble;
  }

  hasWMSCapacity():boolean {
    return this.url!=undefined && this.url.indexOf('gwc/service/wmts')>0;
  }

  isWMTS():boolean {
    return this.type === 'WMTS';
  }

  getScaleZ(): number {
    return this.layer3dConfig.getScaleZ();
  }

  setScaleZ(scale: number): void {
    this.layer3dConfig.setScaleZ(scale);
  }

  getOffsetZ() :number {
    return this.layer3dConfig.getOffsetZ();
  }

  setOffsetZ(offset: number): void {
    this.layer3dConfig.setOffsetZ(offset);
  }

  getOffsetZMin():number {
    return this.layer3dConfig.getOffsetZMin();
  }

  setOffsetZMin(offset: number): void {
    this.layer3dConfig.setOffsetZMin(offset);
  }

  getOffsetZMax():number {
    return this.layer3dConfig.getOffsetZMax();
  }

  setOffsetZMax(offset: number): void {
    this.layer3dConfig.setOffsetZMax(offset);
  }

  getScaleZMin():number {
    return this.layer3dConfig.getScaleZMin();
  }

  setScaleZMin(scale: number): void {
    this.layer3dConfig.setScaleZMin(scale);
  }

  getScaleZMax():number {
    return this.layer3dConfig.getScaleZMax();
  }

  setScaleZMax(scale: number): void {
    this.layer3dConfig.setScaleZMax(scale);
  }

  getStepOffset(): number {
    return this.layer3dConfig.getStepOffset();
  }

  getStepScale(): number {
    return this.layer3dConfig.getStepScale();
  }

  isTilesetScalable(cesiumMapService:any): boolean {
    if (this.cesium_Layer) {
      return cesiumMapService.isTilesetScalable(this);
    }
    return false;
  }

  // fct pour forcer màj opacité dans le cas de la 3D
  forceUpdateOpacity(cesiumMapService:any) {
    if (cesiumMapService && this.cesium_Layer) {
      cesiumMapService.updateLayer(this);
    }
  }

  addError(m: string,code:number=-1) {
    this.error.show=true;
    this.error.message=m;
    this.error.type=code;
  }
  resetErrors() {
    this.error.show=false;
    this.error.message='';
    this.error.type=-1;
  }

  toMapLibre() {
    const oLayerConfigMapLibre = new LayerConfigMapLibre(this);
    return oLayerConfigMapLibre.toMapLibre();
  }

  toQgis(elTagLayerTreeGroup: any, elProjectlayers: any) {
    const oLayerConfigQgis = new LayerConfigQgis(this, elTagLayerTreeGroup, elProjectlayers);
    oLayerConfigQgis.toQgis();
  }
}